import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function Group({ keys, selectedKey, handleSelectedKey }) {
  return (
    <Select value={selectedKey} onChange={handleSelectedKey} variant="standard">
      <MenuItem disabled>Setting:</MenuItem>
      {keys.map((key) => (
        <MenuItem key={key} value={key}>
          {key}
        </MenuItem>
      ))}
    </Select>
  );
}

function NormingItem({ norming, isHighlighted, isTransparant }) {
  const keys = Object.keys(norming);
  const [selectedKey, setSelectedKey] = useState(keys[0]); // default is first key

  const handleSelectedKey = (event) => setSelectedKey(event.target.value);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Typography
        variant="body2"
        color={"textPrimary"}
        sx={{
          opacity: isTransparant && !isHighlighted ? 0.4 : 1,
          fontWeight: isHighlighted ? 500 : 400,
        }}
      >
        {norming[selectedKey]}
      </Typography>
      {keys.length > 1 ? (
        <React.Fragment>
          -
          <Group
            keys={keys}
            selectedKey={selectedKey}
            handleSelectedKey={handleSelectedKey}
          />
        </React.Fragment>
      ) : null}
    </div>
  );
}

function Norming({ data, selectedIndex }) {
  const isNorming =
    data.map((entry) => entry?.norming).filter((entry) => entry !== undefined)
      .length > 0;
  if (!isNorming) return null;
  return (
    <div>
      {data.map((entry, index) =>
        entry?.norming ? (
          <NormingItem
            key={entry.id}
            norming={entry.norming}
            isHighlighted={selectedIndex === index}
            isTransparant={selectedIndex !== null}
          />
        ) : (
          ""
        )
      )}
      <Box padding={2} />
    </div>
  );
}

export default Norming;
